export default {
    device: 'desktop',
    pixel: null,
}